import zh from './zh-Hans'
import it from './it'
import en from './en'

export default {
  en: en,
  zh: zh,
  it: it
}
